define('gameday-index-gdtracking/src/OmnitureGamedaySimPage',['require','exports','module','jquery','tracking/omniture'],function(require,exports,module){
    var $ = require('jquery'),
        OmnitureFactory = require( "tracking/omniture" ),
        Omniture = OmnitureFactory.Omniture;

    function OmnitureGamedaySimPage(props){
        // I'd be good to reuse this for simulating page
        // views on gameday content, so no dynamics.
        props.isDynamic=false;
        delete props.dynamic_component;
        delete props.dynamic_componentAction;

        Omniture.call(this,props);
        
        this.addEvents('event4');
    }

    OmnitureFactory.create(OmnitureGamedaySimPage);

    return OmnitureGamedaySimPage
}); 
